var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-body" }, [
    _c("div", {
      staticClass: "modal-body--alert alert alert-danger d-none",
      attrs: { role: "alert" },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row h-100 w-100" },
      [
        _c("div", { staticClass: "modal-body--preview col-6" }, [
          _vm.currentFile.data.thumbnail
            ? _c("img", {
                staticClass: "modal-body--preview__img",
                attrs: {
                  src: _vm._f("share")(_vm.currentFile.data.thumbnail),
                  alt: "preview",
                },
                on: { load: _vm.handlePreviewLoaded },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "spinner-border modal-body--preview__spinner",
              class: { "d-none": !_vm.isPreviewLoading },
              attrs: { role: "status" },
            },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
          ),
        ]),
        _vm._v(" "),
        _c("FigmaLayersTree", {
          staticClass: "modal-body--layers-wrapper col-6",
          attrs: { tree: _vm.currentFile.data.tree },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row w-100 justify-content-end" }, [
      _vm.isCreatingNewTemplates
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", disabled: _vm.isImporting },
              on: { click: _vm.handleTemplatesImport },
            },
            [
              _vm.isImporting
                ? _c("span", {
                    staticClass: "spinner-border spinner-border-sm",
                    attrs: { role: "status", "aria-hidden": "true" },
                  })
                : _vm._e(),
              _vm._v("\n      Add to template\n    "),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }